module.exports = __webpack_public_path__ + "static/media/cib.87277ba9.jpg";